import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { startOfDay, startOfMonth, startOfYear, subDays, subMonths } from 'date-fns'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatOption, MatSelect } from '@angular/material/select'
import { TranslatePipe } from '@ngx-translate/core'
import { FormsModule } from '@angular/forms'

export type TimeInterval = { from: Date | null; to: Date | null }
export type IntervalKey = 'ALL_TIME' | 'TODAY' | 'YESTERDAY' | 'LAST_WEEK' | 'LAST_30_DAYS' | 'LAST_3_MONTHS' | 'LAST_6_MONTHS' | 'LAST_12_MONTHS' | 'THIS_YEAR'

export function convertIntervalKeyToTimeInterval(key: IntervalKey): TimeInterval {
  const now = new Date()

  switch (key) {
    case 'ALL_TIME': {
      return { from: null, to: null }
    }
    case 'TODAY': {
      const start = startOfDay(now)
      return { from: start, to: null }
    }
    case 'YESTERDAY': {
      const start = subDays(startOfDay(now), 1)
      return { from: start, to: startOfDay(now) }
    }
    case 'LAST_WEEK': {
      const start = subDays(startOfDay(now), 7)
      return { from: start, to: null }
    }
    case 'LAST_30_DAYS': {
      const start = subDays(startOfDay(now), 30)
      return { from: start, to: null }
    }
    case 'LAST_3_MONTHS': {
      const start = startOfMonth(subMonths(startOfDay(now), 3))
      return { from: start, to: null }
    }
    case 'LAST_6_MONTHS': {
      const start = startOfMonth(subMonths(startOfDay(now), 6))
      return { from: start, to: null }
    }
    case 'LAST_12_MONTHS': {
      const start = startOfMonth(subMonths(startOfDay(now), 12))
      return { from: start, to: null }
    }
    case 'THIS_YEAR': {
      const start = startOfYear(now)
      return { from: start, to: null }
    }
  }
}

@Component({
  selector: 'app-time-interval',
  imports: [MatFormField, MatLabel, MatSelect, MatOption, TranslatePipe, FormsModule],
  templateUrl: './time-interval.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './time-interval.component.scss',
})
export class TimeIntervalComponent {
  @Input({ required: true })
  selectedInterval!: IntervalKey

  @Input()
  intervalKeys: IntervalKey[] = ['ALL_TIME', 'TODAY', 'YESTERDAY', 'LAST_WEEK', 'LAST_30_DAYS', 'LAST_3_MONTHS', 'LAST_6_MONTHS', 'LAST_12_MONTHS', 'THIS_YEAR']

  @Output()
  update = new EventEmitter<IntervalKey>()

  onIntervalKeyChange(key: IntervalKey) {
    this.update.emit(key)
  }
}
